module.exports = __webpack_public_path__ + "static/media/header-loc.73b80645.svg";